import React from 'react';
import Typography from '~/components/Typography';

const ViewCountCell = ({ viewCount }: { viewCount: number }): React.ReactElement => {
  return <Typography size="sm">{viewCount}</Typography>;
};

export default ViewCountCell;
